function mmSlideProduct() {
    var splideElemMain = document.querySelector("#main-slider");
    // SLIDER PRODUCT
    if (splideElemMain) {
        var main = new Splide(splideElemMain, {
            type: "slide",
            pagination: false,
            arrows: false,
            perPage: 1,
            breakpoints: {
                768: {
                    pagination: true,
                },
            },
        });
        main.mount();
      document.querySelectorAll('.mm-product-media-thumbnail-elem').forEach(function(elem){
        elem.addEventListener('click', function(e){
          main.go( parseInt(elem.dataset.index) )
        })
      })
    }
}

document.addEventListener("DOMContentLoaded", () => {
    mmSlideProduct();
    //mmSlideProductReassurance();
});

// Medias select
function selectMedia(clickedElem) {
  elems = document.querySelectorAll('.mm-product-media-thumbnail-elem');

  elems.forEach(function(elem) {
    elem.classList.remove('mm-selected');
  })
  
  clickedElem.classList.add('mm-selected');
}

// Ouverture des dropdowns
var allDropdown = document.querySelectorAll(".mm-product-form-dropdown");
allDropdown.forEach((content) => {
    content.addEventListener("click", function () {
        checkDropdown(content, false);
    });
    checkDropdown(content, true);
});
function checkDropdown(dropdown, load) {
    if (load && dropdown.classList.contains("active")) {
        const content = dropdown.nextElementSibling;
        content.style.height = content.scrollHeight + "px";
    } else if (!load) {
        dropdown.classList.toggle("active");
        const content = dropdown.nextElementSibling;
        if (content.style.height) {
            content.style.height = null;
        } else {
            content.style.height = content.scrollHeight + "px";
        }
        allDropdown.forEach((elem) => {
            if (elem != dropdown) {
                elem.classList.remove("active");
                elem.nextElementSibling.style.height = null;
            }
        });
    }
}

// STICKY CTA DISPLAY ONLY WHEN SCROLL AFTER TRUE CTA
var derniere_position_de_scroll_connue = 0;
var ticking = false;
var CTA = document.querySelector(".mm-main-product-button-container");
var CTA_position = CTA.offsetTop - window.screen.height / 3;

function faireQuelqueChose(position_scroll) {
    if (position_scroll > CTA_position) {
        CTA.classList.add("mm-cta-sticky");
    } else {
        CTA.classList.remove("mm-cta-sticky");
    }
}

window.addEventListener("scroll", function (e) {
    derniere_position_de_scroll_connue = window.scrollY;
    if (!ticking) {
        window.requestAnimationFrame(function () {
            faireQuelqueChose(derniere_position_de_scroll_connue);
            ticking = false;
        });
    }

    ticking = true;
});

class VariantSelector extends HTMLElement {
    constructor() {
        super();
        this.cached = {};
        this.container = this.closest("#product-form");
        this.addEventListener("change", this.onVariantChange);
    }

    onVariantChange() {
        this.getSelectedOptions();
        this.getSelectedVariant();

        if (this.currentVariant) {
            this.updateURL();
            this.variantFetch();
            this.mmValidateCTA();
        }
    }

    getSelectedOptions() {
        this.options = Array.from(this.querySelectorAll(".mm-product-form-variant-values"), (select) => select.value);
    }

    getVariantJSON() {
        this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    getSelectedVariant() {
        this.currentVariant = this.getVariantJSON().find((variant) => {
            const findings = !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);

            if (findings) return variant;
        });
    }

    updateURL() {
        window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    variantFetch() {
        var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

        if (this.cached[variantUrl]) {
            this.renderVariantInfo(this.cached[variantUrl]);
            return;
        }

        fetch(variantUrl)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, "text/html");
                this.cached[variantUrl] = html;
                this.renderVariantInfo(html);
            })
            .catch((e) => {
                console.error(e);
            });
    }

    renderVariantInfo(html) {
        this.updateElementOuter("#product_id", html);
        this.updateElementOuter(".mm-main-product-button-container", html);
        document.querySelector('.mm-product-sticky-cta .mm-btn-primary').innerHTML = html.querySelector('.mm-main-product-button-container .mm-btn-primary').innerHTML;
    }

    mmValidateCTA() {
      let selectElem = document.querySelector('.mm-product-form-variant-values');
      let CTAs = document.querySelectorAll('.cartbutton');
      if (selectElem.value != "") {
        CTAs.forEach(function(CTA){
          CTA.style.display = 'block';
        })    
      } else {
        CTAs.forEach(function(CTA){
          CTA.style.display = 'none';
        })  
      }
    }

    /**
     *
     * @param {string} selector
     * @param {HtmlElement} html
     */
    updateElement(selector, html) {
        const destination = this.container.querySelector(selector);
        const source = html.querySelector(selector);
        if (source && destination) destination.innerHTML = source.innerHTML;
    }

    updateElementOuter(selector, html) {
        const destination = this.container.querySelector(selector);
        const source = html.querySelector(selector);
        if (source && destination) destination.outerHTML = source.outerHTML;
    }
}
customElements.define("variant-selector", VariantSelector);

/* BOLD CODE */

waitForElm('.bold-ro__product').then((elm) => {
  document.querySelector('.mm-main-product-button-container .mm-product-subscription').classList.remove('mm-locked');
  document.getElementById('mmPercentBold').innerText = document.querySelector('.bold-ro__discount-percentage').value;
});

// GIFT CARD

function setCtaIfvariantSelector() {
  let CTAs = document.querySelectorAll('.cartbutton');
  const variantSelector = document.querySelector('.mm-product-form-variant-values');
  if(variantSelector) {
    CTAs.forEach(function(CTA){
      CTA.style.display = 'none';
    })
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
  setCtaIfvariantSelector();
});






